import { getActionTypes } from '../../../../HelperMethods/UtilityFunctions';

const initialState = {
  distanceFromSite: null,
  durationFromSite: null,
};

const actionTypes = getActionTypes('taskCardReducer')(['SET_TASK_KPIS']);

export function setTaskKpis(distance, duration) {
  return { type: actionTypes.SET_TASK_KPIS, distance, duration };
}

export function setErrorKpis() {
  return { type: 'SET_ERROR_KPIS' };
}

export default function taskCardReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_TASK_KPIS: {
      return { ...state, distanceFromSite: action.distance, durationFromSite: action.duration };
    }
    default: {
      return state;
    }
  }
}
